import { Flex, Button } from '@radix-ui/themes';

const FOLLOW_UP_PROMPTS = [
  'Summarize this',
  'Show me a chart',
  'What should I do next?',
  'Go deeper',
];

interface FollowUpsProps {
  onSelect: (prompt: string) => void;
  visible: boolean;
}

export function FollowUps({ onSelect, visible }: FollowUpsProps) {
  if (!visible) {
    return null;
  }

  return (
    <Flex gap="2" wrap="wrap">
      {FOLLOW_UP_PROMPTS.map((prompt) => (
        <Button
          key={prompt}
          variant="soft"
          color="gray"
          size="1"
          radius="full"
          onClick={() => onSelect(prompt)}
        >
          {prompt}
        </Button>
      ))}
    </Flex>
  );
}
